var _path, _g, _path2, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_322_1093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 45,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 22C40.4999 17.6 36 13.2 31.4999 8.79999L27 13.2L36 22C31.5001 26.4 27 30.8 22.5001 35.2C18 30.8 13.5001 26.4 9.00025 22L18.0002 13.2L13.4999 8.79999C9 13.2 4.50012 17.6 0 22C7.49987 29.3333 15 36.6667 22.4999 44C30 36.6667 37.4999 29.3333 45 22Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_322_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 8.79999H0V44H45V8.79999Z",
    fill: "url(#paint0_linear_322_1093)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22L22.4999 26.4L27 22L22.4999 17.6L18 22Z",
    fill: "#A20417"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_322_1093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 0,
    width: 9,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.4L22.4999 8.8L27 4.4L22.4999 0L18 4.4Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_322_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 0H18V8.8H27V0Z",
    fill: "url(#paint1_linear_322_1093)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_322_1093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 8,
    width: 18,
    height: 23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.864 30.9329C38.9094 27.9553 41.9547 24.9776 45 22C40.4999 17.6 36 13.2 31.4999 8.79999L27 13.2L35.2353 21.2523C35.5368 21.5347 36.0366 22.0396 36.0366 22.0396C38.4789 24.7358 38.5455 28.3025 35.864 30.9329Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_322_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 8.79999H27V30.9329H45V8.79999Z",
    fill: "url(#paint2_linear_322_1093)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_322_1093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 18,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13596 30.9329C6.09064 27.9553 3.04532 24.9776 0 22C4.50012 17.6 9 13.2 13.4999 8.79999L17.9997 13.2L9.76471 21.2523C9.46323 21.5347 8.96344 22.0396 8.96344 22.0396C6.52107 24.7358 6.45422 28.3025 9.13596 30.9329Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_322_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8.79999H0V30.9329H18V8.79999Z",
    fill: "url(#paint3_linear_322_1093)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13608 30.9329C9.13608 30.9329 7.11714 26.7183 10.3252 23.2957C9.88402 22.8643 9.44257 22.4326 9.00137 22.0013C8.97708 22.0255 8.96331 22.0394 8.96331 22.0394C6.52169 24.7349 6.45434 28.3 9.13358 30.9302C9.13433 30.9314 9.13533 30.9322 9.13608 30.9329Z",
    fill: "#440008"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8642 30.9329C35.8642 30.9329 37.8831 26.7183 34.6748 23.2957C35.1163 22.8643 35.5575 22.4326 35.9987 22.0013C36.0229 22.0255 36.0367 22.0394 36.0367 22.0394C38.4783 24.7349 38.5459 28.3 35.8667 30.9302C35.8657 30.9314 35.8649 30.9322 35.8642 30.9329Z",
    fill: "#440008"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.364258 21.6436C1.93049 20.1631 8.44255 14.5105 17.9095 13.1116L13.4996 8.79999C9.12112 13.0812 4.74269 17.3624 0.364258 21.6436Z",
    fill: "#007144"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4999 8.79999L27 13.1995C32.4947 14.1162 38.5766 16.7031 44.9997 22C40.4999 17.6 36 13.2 31.4999 8.79999Z",
    fill: "#007144"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_322_1093",
    x1: 22.4999,
    y1: 26.3994,
    x2: 22.4999,
    y2: 44.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A20417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_322_1093",
    x1: 22.5,
    y1: 8.5,
    x2: 22.5,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02D07E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_322_1093",
    x1: 36.0711,
    y1: 26.6428,
    x2: 35.8867,
    y2: 8.66269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02D07E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_322_1093",
    x1: 9.07401,
    y1: 26.9196,
    x2: 8.8896,
    y2: 8.93955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02D07E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1bad0e4f03a386272987cc98160299fe.svg";
export { ForwardRef as ReactComponent };